import React from 'react'
import { CFImage, CFLink, CFView } from 'components'
import { cflogo } from 'images'

export default () => {
  return (
    <CFView column center h="60px" pt="10px">
      <CFView h6 color="black" content mb="5px">
        COPYRIGHT © 2022 CODEFUSION INC.
      </CFView>
      <CFLink href="https://codefusion.tech">
        <CFImage h="22px" src={cflogo} alt="CodeFusion" />
      </CFLink>
    </CFView>
  )
}
